import React, { useContext } from "react";
import { useNavigate } from "react-router-dom";
import { useState } from "react";
import AppContext from "../../AppContext";
import { useEffect } from "react";
import axios from "axios";
import { BASE_FILE_URL, BASE_URL, mapConfig } from "../../constant";
import { GoogleMap, OverlayView, Polyline } from "@react-google-maps/api";
import { useTranslation } from "react-i18next";
import { TooltipComponent } from "@syncfusion/ej2-react-popups";
const { CancelToken } = axios;

const TimeModeSelector = ({ selectedMode, onChange, disabled }) => {
  const timeModes = [
    { id: 3, name: "3 hrs." },
    { id: 6, name: "6 hrs." },
    { id: 0, name: "Today" },
  ];
  return (
    <div className="inline-flex rounded group md:h-6 h-4 md:w-44 w-36 border-black border">
      {timeModes.map((tm) => (
        <button
          type="button"
          className={` md:text-xs text-xxs font-medium text-center w-1/3 px-1 ${
            tm.id === timeModes[0].id
              ? "rounded-tl rounded-bl"
              : tm.id === timeModes[timeModes.length - 1].id
              ? "rounded-tr rounded-br border-l border-black"
              : "border-l border-black"
          }  ${
            selectedMode === tm.id
              ? "bg-black text-white"
              : "text-black bg-white"
          }`}
          onClick={() => onChange(tm.id)}
          disabled={disabled}
          key={tm.id}
        >
          {tm.name}
        </button>
      ))}
    </div>
  );
};

const EndMarker = ({ id, angle, asset }) => {
  const [moving, setMoving] = useState(false);
  useEffect(() => {
    if (asset.timeStamp) {
      const sixXT = 6 * (asset.devices[0].device.interval * 1000);
      const tenXT = 10 * (asset.devices[0].device.interval * 1000);
      const localLastSensorTime = new Date(asset.timeStamp); // Convert lastSensorTime to local time zone

      const timeDiff = new Date() - localLastSensorTime;
      if (timeDiff > tenXT) {
        setMoving(false);
      } else if (timeDiff > sixXT) {
        setMoving(true);
        const criticalTimeout = setTimeout(() => {
          setMoving(false);
        }, tenXT - timeDiff);
        return () => {
          // Clear the timeouts when the component is unmounted or when status changes
          clearTimeout(criticalTimeout);
        };
      } else {
        setMoving(true);
        const warningTimeout = setTimeout(() => {
          setMoving(true);
        }, sixXT - timeDiff); // 1 minute in milliseconds

        // Set status to critical after 2 minutes
        const criticalTimeout = setTimeout(() => {
          setMoving(false);
        }, tenXT - timeDiff);
        return () => {
          // Clear the timeouts when the component is unmounted or when status changes
          clearTimeout(warningTimeout);
          clearTimeout(criticalTimeout);
        };
      }
    }
  }, [asset.timeStamp]);

  return (
    <div
      style={{
        transform: "translate(-19px, -30px)",
        position: "relative",
      }}
      className="h-fit w-fit "
    >
      <div
        className={`${
          asset?.latestAlarm?.status === "critical"
            ? "bg-red-800"
            : asset?.latestAlarm?.status === "warning"
            ? "bg-amber-500"
            : "bg-blue-700"
        } ${
          moving ? "animate-spin-slow" : ""
        } absolute top-1 left-1 w-7 h-7 rounded-full animate-spin-slow`}
      ></div>
      <div
        className={`absolute left-1 top-1 h-7 w-7 ${
          !asset?.latestAlarm?.status ? "info" : asset?.latestAlarm?.status
        }-gradient flex justify-center items-center rounded-full`}
      >
        <div className="h-6 w-6 flex justify-center items-center">
          <img
            className=" h-auto self-center w-4 cursor-pointer image-full"
            alt="asset"
            id={id}
            src={
              asset.mapIconId && !asset.mapIconId.startsWith("0000")
                ? `${BASE_FILE_URL}/${asset.mapIconId}`
                : "trucksvg.svg"
            }
          />
        </div>
      </div>
    </div>
  );
};

const StartMarker = ({ icon }) => (
  <div
    style={{
      transform: "translate(-19px, -30px)",
      position: "relative",
    }}
    className="h-fit w-fit "
  >
    <img
      className={`rounded-full h-6 w-6 cursor-pointer`}
      alt="asset"
      src="homeStart.svg"
    />
  </div>
);

const AnyReactComponent = ({ text, id, alarm, config, asset, t, isParent }) => {
  const navigate = useNavigate();

  const [showPopup, setShowPopup] = useState(false);

  const handleMouseEnter = () => {
    setShowPopup(true);
  };

  const handleMouseLeave = () => {
    setShowPopup(false);
  };

  const getSensorValues = (fp) => {
    const data = asset.parameters.find((p) => p.id === fp.fieldId);
    return data;
  };

  const getPropertyData = (fp) => {
    const data = asset?.properties.find((p) => p.id === fp.fieldId);
    return data;
  };

  return (
    <div
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
      className="relative -mt-6 -ml-5"
    >
      {showPopup && (
        <div
          className={`w-max ${
            asset.latestAlarm
              ? asset.latestAlarm?.status === "warning"
                ? "from-orange-700 to-zinc-900 border-orange-700"
                : asset.latestAlarm?.status === "critical" &&
                  "from-red-700 to-zinc-900 border-red-700"
              : "hover:border-blue-700 from-blue-700 to-zinc-900 border-blue-700"
          } p-2 rounded shadow bg-gradient-to-b border-2 ml-10`}
        >
          <div className="text-xs flex gap-10 justify-between text-white pb-2 font-semibold">
            <p>{asset.name}</p>
            <div className="flex items-center gap-2">
              <button
                type="button"
                onClick={(e, id) => {
                  if (!isParent) navigate(`/details/asset/${asset.id}`);
                  else navigate(`/details/parent/${asset.id}`);
                }}
                className={`text-white border-white child border rounded-4xl w-16 font-medium text-xxs flex justify-center items-center`}
              >
                {t("home.assetList.detailsButtonText")}
              </button>
            </div>
          </div>
          <div className="grid grid-cols-3 gap-y-4 auto-cols-fr">
            {config?.homeConfiguration
              ?.find((x) => asset.assetType?.id === x.assetType?.id)
              ?.fields?.map((fp, index) => {
                const sensorData = getSensorValues(fp);
                const propertyData = getPropertyData(fp);
                return (
                  <div className="flex items-center w-full" key={index}>
                    <div
                      className={`${
                        index === 0 || index === 3 ? "" : "border-l pl-3 pr-1"
                      } flex-col w-full border-zinc-700`}
                    >
                      <div className="text-zinc-400 font-semibold text-xs truncate">
                        {asset && fp.fieldType === "parameter" ? (
                          <>
                            {sensorData?.enabled ? (
                              <div>
                                <label>
                                  {sensorData.value &&
                                  sensorData.type === "Number"
                                    ? parseFloat(sensorData.value).toFixed(2)
                                    : sensorData.value}
                                </label>
                                <label>{sensorData?.unit}</label>
                              </div>
                            ) : (
                              <div className="text-red-500 text-xxs">
                                Disabled
                              </div>
                            )}
                          </>
                        ) : (
                          <label>{propertyData?.value}</label>
                        )}
                      </div>
                      <div className="text-neutral-500 font-medium text-xxs truncate">
                        {fp.fieldType === "parameter" ? (
                          <label>{sensorData?.name}</label>
                        ) : (
                          <label>{propertyData?.key}</label>
                        )}
                      </div>
                    </div>
                  </div>
                );
              })}
          </div>
        </div>
      )}
      <div
        className={`${
          alarm === "critical"
            ? "bg-red-800"
            : alarm === "warning"
            ? "bg-amber-500"
            : "bg-blue-700"
        } absolute top-1 left-1 w-7 h-7 rounded-full animate-spin-slow`}
      ></div>
      <div
        className={`absolute left-1 top-1 h-7 w-7 ${
          !alarm ? "info" : alarm
        }-gradient flex justify-center items-center rounded-full`}
      >
        <div className="h-6 w-6 flex justify-center items-center">
          <img
            className=" h-auto self-center w-4 cursor-pointer image-full"
            alt="asset"
            id={id}
            src={
              asset.mapIconId && !asset.mapIconId.startsWith("0000")
                ? `${BASE_FILE_URL}/${asset.mapIconId}`
                : "trucksvg.svg"
            }
          />
        </div>
      </div>
    </div>
  );
};

const Map = ({ selectedAsset }) => {
  const [animationInterval, setAnimationInterval] = useState();
  const { data, assets, isLoaded, config, darkMode, parentAssetLoc } =
    useContext(AppContext);
  const { t } = useTranslation();
  const [zoomMarker, setZoomMarker] = useState(mapConfig);
  const [map, setMap] = useState(null);
  const [markerIcons, setMarkerIcons] = useState({ start: null, end: null });
  const [loading, setLoading] = useState(false);
  const [liveMarkers, setLiveMarkers] = useState([]);
  const [path, setPath] = useState([]);
  const [timeMode, setTimeMode] = useState(3);
  const [cancelToken, setCancelToken] = useState();
  const [autoCenter, setAutoCenter] = useState(true);

  // const onLoad = useCallback(function callback(map) {

  // }, []);
  // const [assets, setAssets] = useState(asset);
  const renderMarkers = (paths) => {
    if (paths.length > 1) {
      const pathLines = paths.map((p) => p.gnss);
      setMapBounds(pathLines);
      const startLatLng = paths[0].gnss;
      setMarkerIcons({ end: null, start: startLatLng });
      animatePathWithDelay(pathLines, paths[0].timeStamp);
    }
  };

  const onTimeModeChange = (id) => {
    setTimeMode(id);
    clearInterval(animationInterval);
    setMarkerIcons({ start: null, end: null });
    clearPolylinePaths();
    let asset = assets.find((pc) => pc.id === selectedAsset);
    getPathCoordinates(asset, id);
  };

  const clearPolylinePaths = () => {
    setPath([]);
  };

  const animatePathWithDelay = (pathLines, timeStamp) => {
    const numSteps = pathLines.length;
    const delay = 1; // Delay between drawing each segment in milliseconds

    let step = 0;

    if (animationInterval) {
      clearInterval(animationInterval);
    }

    const drawStep = () => {
      if (step === numSteps || !selectedAsset) {
        if (selectedAsset === null) {
          clearPolylinePaths();
          return;
        }
        setMarkerIcons((pre) => ({ ...pre, end: pathLines[numSteps - 1] }));
        setAnimationInterval((pre) => {
          clearInterval(pre);
          return null;
        });
        setLoading(false);
        // Clear the interval when animation is done
        return;
      }
      const segment = pathLines[step];
      setPath((pre) => [...pre, segment]);
      // renderPath(segment);
      step++;
    };

    setAnimationInterval(setInterval(drawStep, delay)); // Store the interval ID
  };

  const cancelRequest = () => {
    setCancelToken((pre) => {
      if (pre) {
        pre.cancel("Request canceled by user");
      }
      return pre;
    });
  };

  const getPathCoordinates = async (asset, mode) => {
    setLoading(true);
    cancelRequest();
    let now = new Date();
    if (mode !== 0) now = new Date(new Date() - mode * 60 * 60 * 1000);
    else now.setHours(0, 0, 0);
    const formattedStartTime = now.toISOString();
    const formattedEndTime = new Date().toISOString();
    const source = CancelToken.source();
    setCancelToken(source);
    try {
      const deviceId = asset.devices[0].device.id;
      const response = await axios.get(
        `${BASE_URL}/api/Asset/GetAssetPathCoordinates?deviceId=${deviceId}&startTime=${formattedStartTime}&endTime=${formattedEndTime}`,
        {
          cancelToken: source.token, // Pass the cancel token to the request
        }
      );

      const data = response.data.map((d) => ({
        gnss: {
          lat: parseFloat(d.gnss.latitude),
          lng: parseFloat(d.gnss.longitude),
        },
        timeStamp: d.timeStamp,
      }));

      if (data.length > 0) {
        renderMarkers(data);
      } else if (asset.gnss && asset.gnss.latitude) {
        const loc = {
          gnss: {
            lat: parseFloat(asset.gnss.latitude),
            lng: parseFloat(asset.gnss.longitude),
          },
          timeStamp: asset.timeStamp,
        };
        setMarkerIcons((pre) => ({ ...pre, end: loc.gnss }));
        // setMarker(loc.gnss, "End Point", endIcon, "end", loc.timeStamp);
        setLoading(false);
      }
    } catch (error) {
      console.error("Error fetching asset path coordinates:", error);
    } finally {
    }
  };

  useEffect(() => {
    clearInterval(animationInterval);
    // clearMapIcons("all");
    setMarkerIcons({ start: null, end: null });
    clearPolylinePaths();
    // clearMapIcons("start");
    if (selectedAsset !== null) {
      let asset = assets.find((pc) => pc.id === selectedAsset);
      if (asset.gnss && asset.gnss.latitude)
        setZoomMarker({
          ...mapConfig,
          center: {
            lat: parseFloat(asset.gnss.latitude),
            lng: parseFloat(asset.gnss.longitude),
          },
        });
      getPathCoordinates(asset, timeMode);
    } else {
      if (
        map &&
        assets?.length > 0 &&
        (assets.some((a) => a.gnss) ||
          (parentAssetLoc && parentAssetLoc.some((x) => x.gnss))) &&
        selectedAsset === null
      ) {
        let markers = [];
        markers = assets
          .filter((x) => x.gnss !== null && !x.parentId)
          .map((a) => ({
            lat: parseFloat(a.gnss?.latitude),
            lng: parseFloat(a.gnss?.longitude),
          }));
        if (parentAssetLoc) {
          parentAssetLoc.forEach((element) => {
            let parentLoc = {
              lat: parseFloat(element.gnss.latitude),
              lng: parseFloat(element.gnss.longitude),
            };
            markers.push(parentLoc);
          });
        }
        setMapBounds(markers);
      }
    }
  }, [selectedAsset]);
  const setMapBounds = (markers) => {
    setAutoCenter((pre) => {
      if (pre) {
        const bounds = new window.google.maps.LatLngBounds();
        markers.map((marker) => {
          bounds.extend({
            lat: marker.lat,
            lng: marker.lng,
          });
        });
        map?.fitBounds(bounds);
      }
      return pre;
    });
  };

  useEffect(() => {
    if (
      map &&
      assets &&
      assets.length > 0 &&
      (assets.some((a) => a.gnss) ||
        (parentAssetLoc && parentAssetLoc.some((x) => x.gnss))) &&
      !selectedAsset
    ) {
      let markers = [];
      markers = assets
        .filter((x) => !x.parentId)
        .map((a) =>
          a.gnss
            ? {
                lat: parseFloat(a.gnss.latitude),
                lng: parseFloat(a.gnss.longitude),
              }
            : null
        )
        .filter((x) => x !== null);
      if (parentAssetLoc) {
        parentAssetLoc.forEach((element) => {
          let parentLoc = {
            lat: parseFloat(element.gnss.latitude),
            lng: parseFloat(element.gnss.longitude),
          };
          markers.push(parentLoc);
        });
      }
      setMapBounds(markers);
    }
  }, [assets, map]);

  const handleApiLoaded = (map) => {
    setMap(map);
    const bounds = new window.google.maps.LatLngBounds();
    map.fitBounds(bounds);
  };

  useEffect(() => {
    if (selectedAsset !== null) {
      // clearMapIcons("end");
      const asset = assets.find((pc) => pc.id === selectedAsset);
      if (
        !data.gnss ||
        data.gnss.Latitude === 0 ||
        asset.devices[0].device.id !== data.deviceId
      ) {
        return;
      }

      const value = {
        lat: parseFloat(data.gnss.Latitude),
        lng: parseFloat(data.gnss.Longitude),
      };
      setAutoCenter((pre) => {
        if (pre)
          setZoomMarker({
            ...mapConfig,
            center: value,
          });
        return pre;
      });

      if (!loading) {
        setMarkerIcons((pre) => ({ ...pre, end: value }));
        setLiveMarkers((pre) => {
          if (pre.length > 0) {
            setPath((p) => [...p, ...pre.map((x) => x.gnss)]);
          }
          return [];
        });
        setPath((p) => [...p, value]);
      } else {
        setLiveMarkers((pre) => [
          ...pre,
          { gnss: value, timeStamp: data.timeStamp },
        ]);
      }
    }
  }, [data]);
  return (
    <>
      {isLoaded ? (
        <GoogleMap
          onLoad={handleApiLoaded}
          // center={zoomMarker?.center}
          options={{
            styles: darkMode ? zoomMarker.styles : zoomMarker.styleLight,
            mapTypeControl: true,
            streetViewControl: false,
            // mapTypeControlOptions: {
            //   position: maps.ControlPosition.TOP_RIGHT,
            // },
          }}
          mapContainerStyle={{ height: "100%", width: "100%" }}
        >
          {!selectedAsset &&
            assets &&
            (parentAssetLoc
              ? [...assets.concat(parentAssetLoc)]
              : [...assets]
            ).map((a) => {
              return a.gnss ? (
                <OverlayView
                  position={{
                    lat: a.gnss && a.gnss.latitude,
                    lng: a.gnss && a.gnss.longitude,
                  }}
                  getPixelPositionOffset={{ x: -10, y: 0 }}
                  mapPaneName={OverlayView.OVERLAY_MOUSE_TARGET}
                  key={a.id}
                >
                  <AnyReactComponent
                    id={a.id}
                    key={a.id}
                    config={config}
                    asset={a.isParent ? a.detailsIfParent : a}
                    text={
                      a.latestAlarm?.status === "critical"
                        ? "truckred.svg"
                        : a.latestAlarm?.status === "warning"
                        ? "truckyellow.svg"
                        : "truckblue.svg"
                    }
                    alarm={a.latestAlarm?.status}
                    t={t}
                    isParent={a.isParent}
                  />
                </OverlayView>
              ) : null;
            })}
          {selectedAsset ? (
            <div className="absolute top-14 left-2">
              <TimeModeSelector
                selectedMode={timeMode}
                onChange={onTimeModeChange}
              />
            </div>
          ) : null}
          {map && (
            <button
              type="button"
              className={`absolute md:text-xs rounded-sm ${
                autoCenter ? " bg-blue-500" : "bg-white"
              } text-xxs font-medium text-center w-fit px-2 h-10 top-[10px] right-16  flex justify-center items-center gap-3`}
              onClick={() => setAutoCenter(!autoCenter)}
            >
              {/* {t("home.map.autoCenter")}
              <input
                name="active"
                type="checkbox"
                className="focus:ring-blue-500 h-4 w-4 text-blue-600 border-gray-300 rounded"
                id="inlineCheckbox1"
                onChange={() => setAutoCenter(!autoCenter)}
                checked={autoCenter}
                value={autoCenter}
              ></input> */}
              <TooltipComponent
                content={
                  autoCenter
                    ? t("home.map.autoCenterOn")
                    : t("home.map.autoCenterOff")
                }
                delayUpdate={false}
                key={"autoCenterToggle"}
                immediateRender
                opensOn="Hover"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  height="24px"
                  viewBox="0 0 24 24"
                  width="24px"
                  fill={autoCenter ? "white" : "#5f6368"}
                >
                  <path d="M0 0h24v24H0z" fill="none" />
                  <path d="M12 2C6.49 2 2 6.49 2 12s4.49 10 10 10 10-4.49 10-10S17.51 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8zm3-8c0 1.66-1.34 3-3 3s-3-1.34-3-3 1.34-3 3-3 3 1.34 3 3z" />
                </svg>
              </TooltipComponent>
            </button>
          )}
          <Polyline
            path={path}
            visible={true}
            options={{
              strokeColor: "#0096FF",
              strokeOpacity: 1.0,
              strokeWeight: 2,
            }}
          />
          {selectedAsset && markerIcons.start !== null && (
            <OverlayView
              position={{
                lat: parseFloat(markerIcons.start.lat),
                lng: parseFloat(markerIcons.start.lng),
              }}
              getPixelPositionOffset={{ x: -10, y: 0 }}
              mapPaneName={OverlayView.OVERLAY_MOUSE_TARGET}
            >
              <StartMarker key="start" />
            </OverlayView>
          )}
          {selectedAsset && markerIcons.end !== null && (
            <OverlayView
              position={{
                lat: parseFloat(markerIcons.end.lat),
                lng: parseFloat(markerIcons.end.lng),
              }}
              getPixelPositionOffset={{ x: -10, y: 0 }}
              mapPaneName={OverlayView.OVERLAY_MOUSE_TARGET}
            >
              <EndMarker
                key="end"
                id="end"
                angle={parseFloat(markerIcons.end.angle)}
                asset={assets.find((x) => x.id === selectedAsset)}
              />
            </OverlayView>
          )}
        </GoogleMap>
      ) : null}
    </>
  );
};

export default Map;
